import { useEffect, useState }from 'react'
import Loader from '../components/ui/Loader'
import Button from '../components/ui/Button'
import { useFetching } from '../hooks/useFetching'
import QuestionService from '../api/QuestionService'
import { Link } from 'react-router-dom'

const AnketView = () => {
  const [questions, setQuestions] = useState([])
  const [getQuestions, isQuestionsLoading, questionsErr] = useFetching(async () => {
    const response = await QuestionService.getQuestions()
    setQuestions(response.data)
  })

  useEffect(() => {
    getQuestions()
  }, [])

  return (
    <div className='anket-view'>
        <div className="container">
            <Link to='/student/question/1' state={ {questions: questions}} className="anket-view__start-btn btn">
                Начать анкетирование
            </Link>
            <h2 className="anket-view__title title">Вопросы анкеты "Преподаватель глазами студента"</h2>
            <div className="anket-view__table">
                {
                    isQuestionsLoading 
                        ? <Loader /> 
                        : 
                        <table>
                        <thead>
                            <tr>
                                <th>Номер</th>
                                <th>Текст</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                questions.map(question => {
                                    return (
                                        <tr key={question.id}>
                                            <td>{question.number}</td>
                                            <td>{question.text}</td>
                                        </tr>
                                    )
                                })
                            }
                        </tbody>
                    </table>
                }
            </div>
        </div>
    </div>
  )
}

export default AnketView